export enum TranslationTabs {
  LanguageSettings = 0,
  Translations = 1
}
